import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import styles from './CreateEditItemModal.module.scss'
import {OrangeButton} from "../../../../../../../com/pagesTab/orangeBtn/OrangeButton";
import {PromoDto, PromoItemsDto} from "../../../../../../../../dtos";
import {AsyncImageWithLoader} from "../../../../../../../../com/imageWithLoader/imageWithLoader";
import {useDispatch} from "react-redux";
import {
    createPromotionItem, deleteImageFromItems,
    editPromotionItem,
} from "../../../../../../../../store/actionCreators/promotionsItemsCreators";
import {useTypedSelector} from "../../../../../../../../hooks/useTypeSelector";
import {ReactComponent as ImageWithError} from "../../../../../../../../assets/promos&items/image_error.svg";
import {AddDeleteImageModal} from "../AddDeleteImageModal/AddDeleteImageModal";
import {FileInput} from "../../../../../../../com/FileInput/FileInput";
import {ReactComponent as UploadImageIcon} from "../../../../../../../../assets/promos&items/upload_icon.svg";
import {ReactComponent as DeleteImageIcon} from "../../../../../../../../assets/promos&items/delete_icon.svg";
import {Button, createTheme, ThemeProvider} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {ImagePreviewPopup} from "../../../../../../../com/tooltipPreviewOnlyImage/imagePreview";
import {PageSpinner} from "../../../../../../../com/pagesTab/pagesSpinner/spinner";
import {SimpleConfirmPopup} from "../../../../../../../../com/simpleConfirmPopup/SimpleConfirmPopup";
import {ClosePopupBtn} from "../../../../../../../../com/closePopupBtn/closePopupBtn";
import {NonImagePlaceholder} from "../../../../../../../com/nonImagePlaceholder/nonImagePlaceholder";


const theme = createTheme({
    components: {
        // Name of the component
        MuiTooltip: {
            styleOverrides: {
                // Name of the slot
                tooltip: {
                    // Some CSS
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    maxWidth: '620px',
                    width: '620px',
                    maxHeight: '620px',
                    border: '1px solid #4D4D4D',
                    borderRadius: '5px',
                },
                popper: {
                    zIndex: 1501
                }
            },
        },
    },
});


interface Props {
    isShow: boolean;
    defaultContentForModal: PromoItemsDto,
    isNewItem: boolean;
    setOpenItemModal: (value: boolean) => void;
    promo: PromoDto;
    lang: string;
    imageSrc: string;
    isUnlinkPromo?: boolean;
}

interface ErrorsForField {
    isEmptyItemCode: boolean;
    isEmptyItemCaption: boolean;
    // isEmptySrcForImage: boolean;
    isEmptyRegularPrice: boolean;
}


export const CreateEditItemModal: React.FC<Props> = (
    {
        isShow,
        defaultContentForModal,
        isNewItem,
        setOpenItemModal,
        promo,
        lang,
        imageSrc,
        isUnlinkPromo,
    }
) => {
    const dispatch = useDispatch();
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const [defaultItemState, setDefaultItemState] = useState<PromoItemsDto>(defaultContentForModal);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const [itemState, setItemState] = useState<PromoItemsDto>(defaultContentForModal);
    const [itemPromoState, setItemPromoState] = useState<PromoDto>(promo);
    const [isHidden, setHiddenItemPopup] = useState<boolean>(false);
    // const [imageSrcState, setImageSrcState] = useState<string>(imageSrc);
    // const [withTooltip, showTooltip] = useState<boolean>(true);
    const [emptyFields, setEmptyFields] = useState<ErrorsForField>({
        isEmptyItemCode: false,
        isEmptyItemCaption: false,
        // isEmptySrcForImage: false,
        isEmptyRegularPrice: false,
    })
    const [isLoading, setLoadingWrapper] = useState<boolean>(false);
    const [selectedImageFile, setImageFile] = useState<File | null>();


    //image popup
    const [isOpenImagePopup, setImagePopupStatus] = useState<boolean>(false);

    //item confirm popup
    const [isShowConfirmExitPopup, setShowConfirmExitPopup] = useState(false);
    const [isRequiredFieldsNotFilled, setIsRequiredFieldsNotFilled] = useState<boolean>(false);


    useEffect(() => {
        setItemState({
            ...itemState,
            fpiImage: imageSrc
        })
        // setImageSrcState(imageSrc);
    }, [imageSrc]);

    useEffect(() => {
        if (selectedImageFile) {
            let newSrc = URL.createObjectURL(selectedImageFile);
            // setImageSrcState(newSrc);
            setItemState({
                ...itemState,
                fpiImage: newSrc
            })
            // showTooltip(true);
        }
    }, [selectedImageFile])

    useEffect(() => {
        const data = {
            ...defaultContentForModal,
            fpiImage: isNewItem ? '' : imageSrc
        }
        setItemState(data);
        setDefaultItemState(data);
        setEmptyFields({
            isEmptyItemCode: !Boolean(defaultContentForModal.fpiCode),
            isEmptyItemCaption: !Boolean(defaultContentForModal.fpiCaption),
            // isEmptySrcForImage: !Boolean(defaultContentForModal.fpiImage),
            isEmptyRegularPrice: flyerDetailsState.flyFltRec.fltCode === 3 ? false : !Boolean(defaultContentForModal.fpiRegularPrice),
        })
        setItemPromoState(promo);

        document.documentElement.addEventListener('paste', pasteImage)
        return () => {
            document.documentElement.removeEventListener('paste', pasteImage)
        }
    }, []);


    useEffect(() => {
        setLoadingWrapper(promotionsItemsState.isLoading);
        if (promotionsItemsState.type === "EDIT_PROMOTION_ITEM_SUCCESS" || promotionsItemsState.type === "CREATE_PROMOTION_ITEM_SUCCESS") {
            setOpenItemModal(false);
        }
    }, [promotionsItemsState.type])


    const onChangeItemCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;

        // const isNumeric = validator.isNumeric(currentValue);
        // if(isNumeric){
        setItemState({
            ...itemState,
            fpiCode: e.target.value
        })
        // }
        if (currentValue === '') {
            setEmptyFields({
                ...emptyFields,
                isEmptyItemCode: true
            })
        } else {
            setEmptyFields({
                ...emptyFields,
                isEmptyItemCode: false
            })
        }
    }

    const onChangeItemCaption = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;

        setItemState({
            ...itemState,
            fpiCaption: currentValue
        })

        if (currentValue === '') {
            setEmptyFields({
                ...emptyFields,
                isEmptyItemCaption: true
            })
        } else {
            setEmptyFields({
                ...emptyFields,
                isEmptyItemCaption: false
            })
        }

    }
    const onChangeItemRegularPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;
        if (currentValue.indexOf('.') > -1) {
            if (currentValue.indexOf('.') + 3 >= currentValue.length) {
                setItemState({
                    ...itemState,
                    fpiRegularPrice: e.target.value
                })
            }
        } else {
            setItemState({
                ...itemState,
                fpiRegularPrice: e.target.value
            })
        }

        if (currentValue === '' && flyerDetailsState.flyFltRec.fltCode !== 3) {
            setEmptyFields({
                ...emptyFields,
                isEmptyRegularPrice: true
            })
        } else {
            setEmptyFields({
                ...emptyFields,
                isEmptyRegularPrice: false
            })
        }
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const invalidChars = ["-", "+", "e", "E"]; //include "." if you only want integers
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
            return;
        }
    }
    // const onChangePromotionType = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const isNumeric = validator.isNumeric(e.target.value);
    // }
    //
    // const onChangeItemDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    //
    // }
    //
    // const onChangeFamilyCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const isNumeric = validator.isNumeric(e.target.value);
    // }

    const onChangeItemKeyword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setItemState({
            ...itemState,
            fpiKeywords: e.target.value
        })
    }

    const onBlur = (e: any) => {
        const value = e.target.value;
        setItemState({
            ...itemState,
            fpiRegularPrice: Number(value).toFixed(2)
        })
    }

    const pasteImage = (e: any) => {
        // const e = je;
        for (let i = 0; i < e.clipboardData.items.length; i++) {
            let item = e.clipboardData.items[i];
            console.log('Item: ' + item.type);
            if (item.type.indexOf('image') != -1) {
                //item.
                onFileSelected(item.getAsFile());
            } else {
                // ignore not images
                console.log('Discarding not image paste data');
            }
        }
    }

    const onFileSelected = (file: File) => {
        setImageFile(file);
        // dispatch(uploadImageToItem(flyerDetailsState.flyRecId, file, flyerDetailsState.flyLacRec!.lacCode!, item.fpiRecId? item.fpiRecId : null));
    }
    const deleteImage = () => {
        // setImageSrcState('');
        setItemState({
            ...itemState,
            fpiImage: ''
        })
        if (itemState.fpiImage && !isNewItem) {
            dispatch(deleteImageFromItems([itemState.fpiRecId!], flyerDetailsState.flyLacRec!.lacCode!));
        }
        // dispatch(deleteImageFromItems([item.fpiRecId!], flyerDetailsState.flyLacRec!.lacCode!));
    }


    const onSaveItem = () => {
        if (isNewItem) {
            const itemData = {
                id: '',
                flyerId: Boolean(promo.flrRecId) ? (isUnlinkPromo ? promo.flrRecId : null) : flyerDetailsState.flyRecId,
                promoId: Boolean(promo.flrRecId) ? promo.flrRecId : null,
                code: itemState.fpiCode,
                caption: itemState.fpiCaption,
                displayCaption1: itemState.fpiCaption,
                displayCaption2: '',
                regularPrice: Number(itemState.fpiRegularPrice),
                keywords: itemState.fpiKeywords ? itemState.fpiKeywords : '',
                file: selectedImageFile
            }
            // dispatch(createItem(itemData, lang));
            dispatch(createPromotionItem(itemData, lang, itemState.fpiImage!, flyerDetailsState.flyFltRec.fltCode !== 3));
        } else {
            const itemData = {
                id: itemState.fpiRecId,
                flyerId: Boolean(promo.flrRecId) ? (isUnlinkPromo ? promo.flrRecId : null) : flyerDetailsState.flyRecId,
                promoId: Boolean(promo.flrRecId) ? promo.flrRecId : null,
                code: itemState.fpiCode,
                caption: itemState.fpiCaption,
                displayCaption1: itemState.fpiCaption,
                displayCaption2: itemState.fpiDisplayCaption2,
                regularPrice: Number(itemState.fpiRegularPrice),
                keywords: itemState.fpiKeywords ? itemState.fpiKeywords : '',
                file: selectedImageFile
            }
            // dispatch(updateItem(itemData, lang));
            dispatch(editPromotionItem(itemData, lang, itemState.fpiImage!, flyerDetailsState.flyFltRec.fltCode !== 3));
        }
    }

    const openImagePopup = (isOpen: boolean) => {
        setHiddenItemPopup(isOpen);
        setImagePopupStatus(isOpen);
    }

    const compareDefaultItemStateWithCurrentItemState = (): boolean => {
        const stringDefaultState = JSON.stringify(itemState);
        const stringCurrentState = JSON.stringify(defaultItemState);
        return stringDefaultState !== stringCurrentState;
    }

    const checkStatesBeforeLeave = () => {
        const isStateWasChanged = compareDefaultItemStateWithCurrentItemState();
        if (isStateWasChanged) {
            setShowConfirmExitPopup(true);
        } else {
            setOpenItemModal(false)
        }
    }

    const checkerBeforeSavePromoDetails = () => {
        if (
            JSON.stringify(emptyFields).indexOf('true') > -1
        ) {
            setIsRequiredFieldsNotFilled(true);
        } else {
            onSaveItem();
        }
    };

    const onCloseWithoutSaving = () => {
        setOpenItemModal(false)
    }

    const confirmErrorPopup = () => {
        setIsRequiredFieldsNotFilled(false);
    }


    return (
        <>
            <Modal dialogClassName={`${styles.add_edit_item_modal} ${isHidden ? styles.hidden_popup : ''}`}
                   show={isShow}>
                <div className={styles.header_modal}>
                    <div>
                        {isNewItem ? 'Add Item' : 'Edit Item'}
                    </div>
                    <ClosePopupBtn onClose={checkStatesBeforeLeave}/>
                </div>
                <div className={styles.content_modal}>
                    <div className={`${styles.row_in_modal}`}>
                        <div className={`${styles.column} ${styles.wideColumn}`}>
                            <div className={styles.caption}>
                                Item Code
                            </div>
                            <div className={styles.input_wrapper}>
                                <input
                                    type="text"
                                    value={itemState.fpiCode}
                                    onChange={onChangeItemCode}
                                    className={`
                                    ${styles.requiredField}
                                    ${emptyFields.isEmptyItemCode ? styles.error_signal : ''}
                                    `}
                                />
                            </div>
                        </div>
                        <div className={`${styles.column} ${styles.wideColumn}`}>
                            <div className={styles.caption}>
                                Promotion Code
                            </div>
                            <div className={styles.input_wrapper}>
                                <input type="text" value={itemPromoState.flrCode}
                                       readOnly={true}/>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Item Caption
                            </div>
                            <div className={styles.input_wrapper}>
                                <input
                                    type="text"
                                    value={itemState.fpiCaption}
                                    onChange={onChangeItemCaption}
                                    className={`
                                    ${styles.requiredField}
                                    ${emptyFields.isEmptyItemCaption ? styles.error_signal : ''}
                                    `}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.row_in_modal}`}>
                        <div className={`${styles.image_content}`}>
                            <div className={styles.info_for_image_wrapper}>
                                <div className={styles.caption}>
                                    Lead Image
                                </div>
                                {
                                    itemState.fpiImage && itemState.fpiImage !== '' ?
                                        <ThemeProvider theme={theme}>
                                            <Tooltip
                                                enterDelay={500}
                                                enterNextDelay={500}
                                                title={<ImagePreviewPopup
                                                    src={itemState.fpiImage}
                                                />}
                                                placement={"right-start"}
                                            >
                                                <div className={styles.image_wrapper}>
                                                    <AsyncImageWithLoader src={itemState.fpiImage}
                                                                          notUploadIcon={<NonImagePlaceholder/>}/>
                                                </div>
                                            </Tooltip>
                                        </ThemeProvider> :
                                        <div className={styles.image_wrapper}>
                                            <AsyncImageWithLoader src={itemState.fpiImage!}
                                                                  notUploadIcon={<NonImagePlaceholder/>}/>
                                        </div>
                                }

                                <div className={`${styles.upload_icon_wrapper} ${styles.images_controls}`}
                                     title={"Upload an Item Image"}
                                >
                                    <FileInput
                                        onFileSelected={onFileSelected}
                                        icon={(
                                            <UploadImageIcon/>
                                        )}
                                        validFileExtensions={`.jpg,.jpeg,.png`}
                                        isMultipleSelection={false}
                                    />
                                </div>
                                <Button
                                    title={"Frame's screenshot to become the item's image."}
                                    onClick={deleteImage} disabled={!(itemState.fpiImage && !isNewItem)}>
                                    <DeleteImageIcon
                                        style={{
                                            opacity: !(itemState.fpiImage && !isNewItem) ? 0.5 : 1
                                        }}
                                    />
                                </Button>
                            </div>
                        </div>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Regular Item Price
                            </div>
                            <div className={styles.input_wrapper}>
                                <input
                                    type="number"
                                    value={itemState.fpiRegularPrice}
                                    onChange={onChangeItemRegularPrice}
                                    onBlur={onBlur}
                                    onKeyDown={onKeyDown}
                                    className={`
                                    ${flyerDetailsState.flyFltRec.fltCode !== 3 ? styles.requiredField : ''}
                                    ${emptyFields.isEmptyRegularPrice && flyerDetailsState.flyFltRec.fltCode !== 3 ? styles.error_signal : ''}
                                    `}
                                    disabled={flyerDetailsState.flyFltRec.fltCode === 3}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Keywords
                            </div>
                            <div className={styles.input_wrapper}>
                                <input type="text" value={itemState.fpiKeywords ? itemState.fpiKeywords : ''}
                                       onChange={onChangeItemKeyword}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.footer_modal}>
                    <div
                        className={`${styles.save_wrap}}`}>
                        <OrangeButton buttonName={'SAVE'}
                                      isDisabled={JSON.stringify(emptyFields).indexOf('true') > -1 || !compareDefaultItemStateWithCurrentItemState()}
                                      onClick={onSaveItem}/>
                    </div>
                </div>
                {isLoading &&
                    <div className={styles.isLoading}>
                        <PageSpinner/>
                    </div>
                }
            </Modal>
            {isOpenImagePopup &&
                <AddDeleteImageModal
                    isShow={isOpenImagePopup}
                    setOpenImageModal={openImagePopup}
                    src={itemState.fpiImage ? itemState.fpiImage : ''}
                    caption={itemState.fpiDisplayCaption1 ? itemState.fpiDisplayCaption1 : ''}
                    item={itemState}
                    setItemState={setItemState}
                />
            }
            {isShowConfirmExitPopup && (
                <SimpleConfirmPopup
                    onClose={setShowConfirmExitPopup}
                    contentText={`Save changes?`}
                    onConfirm={checkerBeforeSavePromoDetails}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={onCloseWithoutSaving}
                />
            )}
            {isRequiredFieldsNotFilled && (
                <SimpleConfirmPopup
                    onClose={setIsRequiredFieldsNotFilled}
                    contentText={`Required fields are not filled.
Please fill them in and try saving again.`}
                    onConfirm={confirmErrorPopup}
                    buttonText={[`OK`]}
                />
            )}

        </>
    )
}